module.exports = __webpack_public_path__ + "static/banner-image-3-7784e752e2c0781efc768d160671444b.png";